export default __webpack_public_path__ + "static/media/giphy.cdb443f5.gif";